import { render, staticRenderFns } from "./select-coordinate.vue?vue&type=template&id=52103861&scoped=true&"
import script from "./select-coordinate.vue?vue&type=script&lang=js&"
export * from "./select-coordinate.vue?vue&type=script&lang=js&"
import style0 from "./select-coordinate.vue?vue&type=style&index=0&id=52103861&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52103861",
  null
  
)

export default component.exports